import { ModalsProvider } from '@speeki/global-ui-components';

import { personalInfoDisclosureUuidVar } from '@boot/reactiveVariables';

export const useOpenInfoModal = () => {
    const openInfoModal = (disclosureUuid: string, isGuest?: boolean) => {
        if (isGuest) {
            ModalsProvider.open('GuestInfoModal');
        } else {
            ModalsProvider.open('PersonalInfoChangeModal');
            personalInfoDisclosureUuidVar(disclosureUuid);
        }
    };

    return { openInfoModal };
};
